<script>
import Header from "@/components/Header.vue";
import {ListLogicMixin} from '@/assets/js/mixins/list-logic-mixin';
import axios from "axios"
import _ from "lodash";
import DcEdit from "@/components/modal/DcEdit.vue";
import DcCreate from "@/components/modal/DcCreate.vue";
import SelectSearch from "@/components/filters/SelectSearch.vue";
import {EventBus} from "@/eventBus";

export default {
  name: "DcList",
  computed: {
    EventBus() {
      return EventBus
    }
  },
  components: {SelectSearch, DcEdit, DcCreate, Header},
  mixins: [
    ListLogicMixin
  ],
  data: () => {
    return {
      apiList: '/api/manager/dc/list',
      apiUrl: '/api/manager/dc/',
      apiMultyDelete: '/api/manager/dc/delete',
      filterOptions: {
        'Country': {
          'options': [],
          'uri': '/api/manager/dc/flat?group=Country',
          'labelField': 'Country',
          'valueField': 'Country'
        },
        'Payment': {
          'options': [],
          'uri': '/api/manager/dc/flat?group=Payment',
          'labelField': 'Payment',
          'valueField': 'Payment'
        },
      },
      emptyFieldValue: {
        "value": "",
        "label": "ANY"
      },
      pageTitle: 'Datacenters',
      pageFilter: '',
      pageTotal: '',
      total: 0,
      title: 'Datacenters',
      allSelected: false,
      filterExact: [],
      items: [],
      queryFilter: [],
      options: [10, 20, 50, 100, 200, 1000],
      currentItem: {},
      itemsSelectedCount: 0,
      modalData: {},
      selectValues: {
        "Payment":"",
        "Country":"",
      },
      limit: "20"
    }
  },
  methods: {
    initFilters() {
      console.log('filterValues', this.filterValues)
    },
    filterChanged() {
      this.filterSend()
    },
    filterSend() {
      let currentQuery = this.$route.query;
      let newFilters = [];
      for (let FieldName in this.filterValues) {
        if (this.filterValues[FieldName] !== '') {
          let data = {};
          data[FieldName] = this.filterValues[FieldName];
          if (this.filterExact.includes(FieldName)) {
            newFilters.push({
              Condition: "=",
              Data: data,
            });
          } else {
            newFilters.push({
              Condition: "ilike",
              Data: data,
            });
          }
        }
      }
      if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(newFilters)})) {
        this.$router.push({query: {filter: JSON.stringify(newFilters)}});
        this.filters = newFilters;
        this.queryFilter = newFilters;
        this.LoadData()
      } else {
        console.log('Filter error: filter duplicate')
      }
    },
    changeFilterValue(event, filter) {
      this.filterValues[filter] = event === null ? "" : event
      if (this.selectValues[filter] !== undefined && this.selectValues[filter] !== null) {
        this.selectValues[filter] = event;
      }
      this.filterSend();
      this.setTitleByFilters();
    },
    editItem(item) {
      this.currentItemId = parseInt(item.Id);
      this.currentItem = item;
      this.$modal.show('DcEdit');
    },
    loadOptions: async  function () {
      await _.forOwn(this.filterOptions, (value, key) => {
        if (value.uri) {
          this.filterOptions[key].options = this.getOptions(value.labelField, value.valueField, value.uri, key)
          this.filterOptions[key].options.push(this.emptyFieldValue);
        }
      })
      this.filterPreparing();
      this.filterQuery();
      this.setFilterValuesFromRoute();
      this.LoadData();
    },
    getOptions: function (labelField, valueField, query, key) {
      const options = []
      axios.post(query, [], this.authRespConf())
          .then(res => {
            if (res === undefined || res === null) {
              return []
            }
            if (res.data.data !== undefined) {
              for (let dataIndex in res.data.data) {
                options.push({
                  value: res.data.data[dataIndex][valueField],
                  label: key.toLowerCase() === 'state' ? this.getStateOptionLabel(res.data.data[dataIndex][labelField]) : res.data.data[dataIndex][labelField],
                });
              }
            }
          });
      return options;
    },
    selectAll: function () {
      this.selectedItemsList = [];
      this.itemsSelectedCount = 0
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
          this.itemsSelectedCount++
        }
      }
      this.setTitleByFilters();
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      for (let FieldName in this.selectValues) {
        this.selectValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      this.$route.query.filter;
      this.filterChanged();
    },
    actionDelete() {
      this.confirmModalTitle = this.itemsSelectedCount > 1 ? 'Confirm delete Datacenters' : 'Confirm delete Datacenter';
      this.confirmModalMsg =
          'Are you sure you want to delete ' +
          document.getElementsByClassName('selected').length +
          ' Datacenter?';
      this.$modal.show('confirm');
    },
    openDeleteItemConfirmation(item) {
      this.confirmModalTitle = `Confirm delete Datacenter: ${item.Name}`;
      this.confirmModalMsg = `Are you sure you want to delete Datacenter ${item.Name}`;
      this.currentItemId = parseInt(item.Id);
      this.$modal.show('confirmItemDelete');
    },
    extractDomain(str) {
      const domainPattern =  /(?:https?:\/\/)?(?:\(|\[)?([^\s\/\)\]]+\.[^\s\/\)\]]+\.[^\s\/\)\]]+|[^\s\/\)\]]+\.[^\s\/\)\]]+(?:\.[^\s\/\)\]]+)?)(?:\)|\])?/i; // eslint-disable-line
      const match = str.match(domainPattern);
      return match ? match[1] : null;
    },
    newItemForm() {
      this.currentNewItemId = 0;
      this.$modal.show('DcCreate');
    },
    isURL(str) {
      const domain = this.extractDomain(str)
      if (!domain) return false;

      const urlPattern =  /(?:https?:\/\/)?(?:\(|\[)?([^\s\/\)\]]+\.[^\s\/\)\]]+\.[^\s\/\)\]]+|[^\s\/\)\]]+\.[^\s\/\)\]]+(?:\.[^\s\/\)\]]+)?)(?:\)|\])?/i;// eslint-disable-line
      return urlPattern.test(domain);
    },
    async copyText(text, e){
      console.error('copyText: ', text);
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          console.log('Content copied to clipboard standard');
          if (e !== undefined && e !== null) {
            if (e.target.tagName === "i" || e.target.tagName === "I") {
              e.target.parentNode.classList.toggle('copied');
              setTimeout(() => {
                e.target.parentNode.classList.toggle('copied');
              }, "5000");
            } else {
              e.target.classList.toggle('copied');
              setTimeout(() => {
                e.target.classList.toggle('copied');
              }, "5000");
            }
          }
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = text;

          // Move textarea out of the viewport so it's not visible
          textArea.style.position = "absolute";
          textArea.style.left = "-999999px";

          document.body.prepend(textArea);
          textArea.select();

          try {
            document.execCommand('copy');
            console.log('Content copied to clipboard alternative');
            if (e !== undefined && e !== null) {
              if (e.target.tagName === "i" || e.target.tagName === "I") {
                e.target.parentNode.classList.toggle('copied');
                setTimeout(() => {
                  e.target.parentNode.classList.toggle('copied');
                }, "5000");
              } else {
                e.target.classList.toggle('copied');
                setTimeout(() => {
                  e.target.classList.toggle('copied');
                }, "5000");
              }
            }
          } catch (error) {
            console.error(error);
          } finally {
            textArea.remove();
          }
        }
      } catch (err) {
        console.error('Failed to copy: ', err);
        if (e !== undefined && e !== null) {
          if (e.target.tagName === "i" || e.target.tagName === "I") {
            e.target.parentNode.classList.toggle('unoccupied');
            setTimeout(() => {
              e.target.parentNode.classList.toggle('unoccupied');
            }, "5000");
          } else {
            e.target.classList.toggle('unoccupied');
            setTimeout(() => {
              e.target.classList.toggle('unoccupied');
            }, "5000");
          }
        }
      }
    },
    getLink(str) {
      const domain = this.extractDomain(str);
      const httpPattern = /^(?:https?:\/\/)/i;
      if (httpPattern.test(domain)) {
        return domain;
      }
      return `https://${domain}`
    },
    showSidebar(itemId) {
      let link = "#/invoice/list?slim=1"
      if (itemId != '' && itemId !== undefined) {
        link = "#/invoice/list?page=1&filter=[{%22Condition%22:%22=%22,%22Data%22:{%22EntityId%22:"+itemId+"}}]&slim=1"
      }
      if (document.getElementById('side-iframe').src === "") {
        document.getElementById("side-checkbox").checked = true;
        document.getElementById('side-iframe').src = link;
      } else {
        document.getElementById('side-iframe').setAttribute("src","");
        setTimeout(function () {
          document.getElementById("side-checkbox").checked = true;
          document.getElementById('side-iframe').setAttribute("src", link);
        }, 500);
      }
      return false;
    },
    panelClosed() {
      console.log('Panel closed');
      document.getElementById('side-iframe').setAttribute("src","");
      document.getElementById("side-checkbox").checked = false;
      this.LoadData();
    },
    modalsHide() {
      this.$modal.hide('DcEdit');
      this.$modal.hide('DcCreate');
      this.$modal.hide('confirmItemDelete');
      this.$modal.hide('confirm');
    },
  }
  ,
  watch: {
    selectedItemsList(val) {
      this.itemsSelectedCount = val.length
      if (this.itemsSelectedCount === 0) {
        this.allSelected = false
      }
    },
    '$route': function (val) {
      console.log('dc watch $route', val);
      this.setTitleByFilters();
    },
    queryFilter: function () {
      this.setTitleByFilters();
    },
  }
  ,
  created() {
    this.loadOptions();
    EventBus.$on("dc-update", this.handleUpdate);
    EventBus.$on("dc-rq", this.handleUpdate);
    EventBus.$on("dc-add", this.handleAdd);
    EventBus.$on("dc-delete", this.handleDelete);
    EventBus.$on("dc-del", this.handleDelete);
    EventBus.$on("EscapeKeyDown", this.modalsHide);
    EventBus.$on("closedSidebar", this.LoadData);
  },
  beforeDestroy() {
    EventBus.$off("dc-update", this.handleUpdate);
    EventBus.$off("dc-rq", this.handleUpdate);
    EventBus.$off("dc-add", this.handleAdd);
    EventBus.$off("dc-delete", this.handleDelete);
    EventBus.$off("dc-del", this.handleDelete);
    EventBus.$off("EscapeKeyDown", this.modalsHide);
    EventBus.$off("closedSidebar", this.LoadData);
  },
}
</script>

<template>
  <div class="page">
    <Header
        :title=pageTitle
        :filter=pageFilter
        :total=pageTotal
    />
    <div v-show="isDataVisible" class="container dashboard card">
      <div class="card-header">
        <span class="other-buttons">
          <button @click="downloadTable()" class="btn btn-primary">
            <i class="fa fa-download"></i>
          </button>
        </span>
        <span class="other-buttons"><a
            target="_blank"
            v-on:click.prevent.stop="EventBus.$emit('openSidebar', '#/invoice/list');"
            href="#/invoice/list"><button
                                            class="btn btn-primary">Invoices</button></a></span>
        <span class="other-buttons"><button @click="newItemForm()"
                                            class="btn btn-primary">Add Datacenter</button></span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select DCs to delete">
        <button class="btn btn-default delete-btn small icon-only"
                @click="actionDelete()"
                :class="['btn btn-danger', { 'disabled': itemsSelectedCount === 0 }]">
          Delete <span v-if="itemsSelectedCount <= 1">Datacenter</span><span v-else>Datacenters</span> <i
            class="fa fa-trash"></i>
        </button>
        </span>
      </div>
      <div class="card-body">
        <div class="alert alert-info alert-dismissable" v-show="info != ''">
          <strong>
            <b-icon icon="info-circle-fill"></b-icon>
          </strong>
          <div class="alert-text" style="display: inline-block;"> {{ info }}</div>
        </div>
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Id')">ID</span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Name')">Name 🔡</span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" style="width: 15rem; display: block;" @click="SortInvert('Credentials')">Credentials 🔐</span>
              <span class="icon-up" v-show="sortField === 'Address'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Address'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Country')">Country 🗺️</span>
              <span class="icon-up" v-show="sortField === 'Gateway'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Gateway'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Payment')">Payment 💵</span>
              <span class="icon-up" v-show="sortField === 'Mac'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Mac'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('PayDate')">Payment date 💵</span>
              <span class="icon-up" v-show="sortField === 'PayDate'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'PayDate'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Comment')">Comment 💬</span>
              <span class="icon-up" v-show="sortField === 'DcName'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'DcName'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" style="width: 4rem; display: block;" @click="SortInvert('ServerCount')">Servers 🗄</span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" style="width: 3rem; display: block;" @click="SortInvert('VmCount')">VMs 💻</span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" style="width: 4rem; display: block;" @click="SortInvert('UsedIp')">Used IP ɪᴘ</span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" style="width: 4rem; display: block;" @click="SortInvert('FreeIp')">Free IP ɪᴘ</span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" style="width: 3rem; display: block;" @click="SortInvert('AllIp')">All IP ɪᴘ</span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'UsedBy'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th/>
            <th>
              <span class="col-text cursor-pointer">Links 🔗</span>
            </th>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          <tr @keyup.enter="filterChanged()">
            <th/>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues['Name']" placeholder="Name"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="Name" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th/>
            <th>
              <b-form-select
                  :options="filterOptions.Country.options"
                  text-field="label"
                  value-field="value"
                  @change="changeFilterValue($event, 'Country')"
                  v-model="selectValues['Country']"
                  placeholder="ANY"
                  inputId="country"
                  id="Country"
                  clearable/>
              <SelectSearch :handler-func="changeFilterValue" field="Country" :options=filterOptions.Country.options></SelectSearch>
            </th>
            <th>
              <b-form-select
                  style="min-width: 100px;"
                  :options="filterOptions.Payment.options"
                  text-field="label"
                  value-field="value"
                  @change="changeFilterValue($event, 'Payment')"
                  v-model="selectValues['Payment']"
                  placeholder="ANY"
                  inputId="payment"
                  id="Payment"
                  clearable/>
              <SelectSearch :handler-func="changeFilterValue" field="Payment" :options=filterOptions.Payment.options></SelectSearch>
            </th>
            <th/>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues['Comment']" placeholder="Comment"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="Comment" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th>
            <span class="cel-buttons">
              <span class="icon-search" @click="filterChanged()" title="Apply filters"><i
                  class="fa fa-solid fa-search"></i></span>
               <span class="icon-clear" @click="clearFilter()" title="Clear filters">
                <font-awesome-icon icon="recycle" class="icon alt"/>
               </span>
            </span>
            </th>
            <th/>
            <th/>
            <th/>
            <th/>
            <th/>
            <th/>
            <th/>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"
          >
            <td>
              <span class="cel-text">{{ item.Id }}</span>
            </td>
            <td>
              <span class="cel-text"><a v-if="isURL(item.Name)" target="_blank" :href="getLink(item.Name)">{{
                  item.Name
                }}</a><span
                  v-else>{{ item.Name }}</span></span>
            </td>
            <td>
              <span class='dc-table-login'>
                <span class="creds-label">Login: </span>
                <br>
                <span class=" cursor-pointer bold-text creds copy-click" @click="(event) => copyText(item.Login, event)">
                  {{ item.Login }}
                  <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
                </span>
              </span>
              <br>
              <span class='dc-table-password cursor-pointer bold-text'>
                <span class="creds-label">Password: </span>
                <br>
                <span class=" cursor-pointer bold-text creds copy-click" @click="(event) => copyText(item.Password, event)">
                  {{ item.Password }}
                  <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
                </span>
              </span>
            </td>
            <td>
              <span class="cel-text">{{ item.Country }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Payment }}</span>
            </td>
            <td>
              <span class="cel-text" style="max-width: 12rem; display: block;">
                <a
                    target="_blank"
                    v-on:click.prevent="EventBus.$emit('openSidebar', '#/invoice/list?page=1&filter=[{&quot;Condition&quot;:&quot;=&quot;,&quot;Data&quot;:{&quot;EntityId&quot;:${item.Id}}}]');"
                    class="icon-only"
                   :href='`/#/invoice/list?page=1&filter=[{"Condition":"=","Data":{"EntityId":${item.Id}}}]`'>
                  {{ item.PayDates }}
                </a>
              </span>
            </td>
            <td>
              <span class="cel-text">{{ item.Comment }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.ServerCount ?? 0 }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.VmCount ?? 0 }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.UsedIp ?? 0 }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.FreeIp ?? 0 }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.AllIp ?? 0 }}</span>
            </td>
            <td>
              <span class="cel-buttons">
                <button class="btn btn-as-link icon-only" @click="editItem(item)"><i class="fa fa-pencil"></i></button>
                <button class="btn btn-as-link icon-only  text-danger" @click="openDeleteItemConfirmation(item)"><i
                    class="fa fa-trash"></i></button>
              </span>
            </td>
            <td>
               <span class="cel-buttons">
                <a class="btn btn-as-link icon-only"
                   :href='`/#/server/list?page=1&filter=[{"Condition":"=","Data":{"DcId":${item.Id}}}]`'>
                  <img title="Servers" class="item-icon" src="/img/esxi.png">
                </a>
                 <a class="btn btn-as-link icon-only"
                    :href='`/#/ip/list?page=1&filter=[{"Condition":"=","Data":{"DcId":${item.Id}}}]`'>
                  <img title="Servers" class="item-icon" src="/img/ip.png">
                </a>
              </span>
            </td>
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items?.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :default-limit="limit"
            :options="options"
        />
      </div>
    </div>
    <DcEdit type="edit" :itemId="currentItemId" v-on:onSuccess="itemSuccess"/>
    <DcCreate type="create" :itemId="0" v-on:onSuccess="itemSuccess"/>
    <ModalError name="listError" :message="error"/>
    <ModalSuccess name="listSuccess" :message="success"/>
    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        :url="apiUrl"
        :itemId="currentItemId"
    />
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        v-on:onModalСonfirmEvent="modalConfirmEvent"/>

  </div>
</template>

<style scoped>

</style>